import axios from 'axios';
const API_BASE_URL = "https://securelab.api.sehhasolutions.com/api/billing";
//  const API_BASE_URL = "https://localhost:44397/api/billing";


export const billingService = {
  // Get all billing records
getBillingHistory: async (laboratoryId) => {
    const response = await axios.get(`${API_BASE_URL}/laboratory/${laboratoryId}`);
    return response.data;
  },
getSubscriptionDetails: async (laboratoryId) => {
    const response = await axios.get(`${API_BASE_URL}/subscription/${laboratoryId}`);
    return response.data;
  },
  // Submit a new billing record
  submitBilling: async (billingData) => {
    const response = await axios.post(API_BASE_URL, billingData);
    return response.data;
  },
  // Whether the lab's billing is actually overdue: only once the
  // subscription's Next Billing Due date has passed (i.e. the billing
  // cycle has ended), never just because a new calendar month has started.
  checkBillingDue: async (laboratoryId) => {
    try {
      const subscription = await billingService.getSubscriptionDetails(laboratoryId);
      if (!subscription || !subscription.nextDueDate) {
        return { isOverdue: false, subscription: subscription || null };
      }

      const nextDueDate = new Date(subscription.nextDueDate);
      nextDueDate.setHours(0, 0, 0, 0);

      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

      // Overdue only the day AFTER the due date - the due date itself is
      // still within the paid cycle.
      const isOverdue = today > nextDueDate;

      return { isOverdue, subscription };
    } catch (error) {
      console.error('Error checking billing due date:', error);
      // Fail open so an API hiccup never blocks a lab from using the system.
      return { isOverdue: false, subscription: null };
    }
  }
};